const server_url = process.env.REACT_APP_API_URI;

export const fetchMovies = async () => {
  try {
    const response = await fetch(`${server_url}/externalAPI/movies`);
    const data = await response.json();
    return data;
  } catch (error) {
    return null;
  }
};

export const fetchTvShows = async () => {
  try {
    const response = await fetch(`${server_url}/externalAPI/tvshows`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching tvshows:', error);
    return null;
  }
};

export const fetchGames = async () => {
  try {
    const response = await fetch(`${server_url}/externalAPI/games`);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching games:', error);
    return null;
  }
};

export const getmoviefromId = async (id) => {
  try {
    const response = await fetch(`${server_url}/externalAPI/movies/${id}`);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching games:', error);
    return null;
  }
};

export const getTVfromId = async (id) => {
  try {
    const response = await fetch(`${server_url}/externalAPI/tvshows/${id}`);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching games:', error);
    return null;
  }
};

export const getGamefromId = async (id) => {
  try {
    const response = await fetch(`${server_url}/externalAPI/games/${id}`);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching games:', error);
    return null;
  }
};
